import { t } from 'i18next'
import * as Yup from 'yup'
import {
  regexNumberOrDot,
  regexYear,
  codigoPiezaSeparada
} from 'src/components/views/EscritosLexnet/const'
import { FormField } from 'src/enums/Form'
import { TipoProcedimiento, TipologiaProcedimiento } from 'src/interfaces/Catalog'

export type ProcedimientoFormValues = {
  [FormField.PROCEDIMIENTO_NUMERO_FORM]: string
  [FormField.PROCEDIMIENTO_NUMERO_ORIGEN_FORM]: string
  [FormField.PROCEDIMIENTO_NUMERO_PIEZA_FORM]: string
  [FormField.PROCEDIMIENTO_TIPOLOGIA_FORM]: TipologiaProcedimiento | null
  [FormField.PROCEDIMIENTO_TIPO_FORM]: TipoProcedimiento | null
  [FormField.PROCEDIMIENTO_TIPO_ORIGEN_FORM]: TipoProcedimiento | null
  [FormField.PROCEDIMIENTO_YEAR_FORM]: string
  [FormField.PROCEDIMIENTO_YEAR_ORIGEN_FORM]: string
}

export const ProcedimientoFormInitialvalues: ProcedimientoFormValues = {
  [FormField.PROCEDIMIENTO_NUMERO_FORM]: '',
  [FormField.PROCEDIMIENTO_NUMERO_ORIGEN_FORM]: '',
  [FormField.PROCEDIMIENTO_NUMERO_PIEZA_FORM]: '',
  [FormField.PROCEDIMIENTO_TIPOLOGIA_FORM]: null,
  [FormField.PROCEDIMIENTO_TIPO_FORM]: null,
  [FormField.PROCEDIMIENTO_TIPO_ORIGEN_FORM]: null,
  [FormField.PROCEDIMIENTO_YEAR_FORM]: '',
  [FormField.PROCEDIMIENTO_YEAR_ORIGEN_FORM]: ''
}

export const ProcedimientoFormValidations = (): Yup.AnyObjectSchema => {
  return Yup.object().shape({
    [FormField.PROCEDIMIENTO_TIPO_FORM]: Yup.object()
      .nullable()
      .required(t('form.validation.required.default')),
    [FormField.PROCEDIMIENTO_NUMERO_FORM]: Yup.string()
      .matches(regexNumberOrDot, t('form.validation.must_be_number_or_dot'))
      .required(t('form.validation.required.default')),
    [FormField.PROCEDIMIENTO_YEAR_FORM]: Yup.string()
      .nullable()
      .matches(regexYear, t('form.validation.must_be_year'))
      .required(t('form.validation.required.default')),
    [FormField.PROCEDIMIENTO_TIPO_ORIGEN_FORM]: Yup.object()
      .nullable()
      .when([FormField.PROCEDIMIENTO_TIPOLOGIA_FORM], {
        is: (item: TipologiaProcedimiento) => item && item.codigo === codigoPiezaSeparada,
        then: Yup.object()
          .nullable()
          .required(t('form.validation.required.default'))
      }),
    [FormField.PROCEDIMIENTO_NUMERO_ORIGEN_FORM]: Yup.string().when(
      [FormField.PROCEDIMIENTO_TIPOLOGIA_FORM],
      {
        is: (item: TipologiaProcedimiento) => item && item.codigo === codigoPiezaSeparada,
        then: Yup.string().required(t('form.validation.required.default'))
      }
    ),
    [FormField.PROCEDIMIENTO_YEAR_ORIGEN_FORM]: Yup.string()
      .matches(regexYear, t('form.validation.must_be_year'))
      .when(FormField.PROCEDIMIENTO_TIPOLOGIA_FORM, {
        is: (item: TipologiaProcedimiento) => item && item.codigo === codigoPiezaSeparada,
        then: Yup.string().required(' ')
      })
  })
}
